import { Routes } from '@angular/router';
import { SurveyComponent } from './pages/survey/survey.component';
import { browserCompatGuard } from './utils/browser-compat.guard';

export const routes: Routes = [
    { path: '', component: SurveyComponent, canActivate: [browserCompatGuard] },
    { path: ':id', component: SurveyComponent, canActivate: [browserCompatGuard] },
    { path: '**', redirectTo: '' }
];
